import React from 'react';
import type { Editor } from '@tiptap/core';
import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

import './TaskListItemDragHandle.scss';

/**
 * Drag context the node view supplies to the injected (client) drag handle component,
 * so the client can attach drag and drop behaviour to the handle without `src/common`
 * importing client code (mirrors the checkbox/delete/chips injection pattern).
 */
export type TaskItemDragHandleComponentProps = {
    editor: Editor;
    elementId: string;
    // The task item node the handle belongs to (including its nested sub-task subtree)
    node: ProseMirrorNode;
    getPos: () => number;
    // Whether the board allows dragging at all (from its write permission)
    canDrag: boolean;
};

type Props = TaskItemDragHandleComponentProps & {
    DragHandleComponent: React.ComponentType<TaskItemDragHandleComponentProps>;
};

const TaskListItemDragHandle: React.FC<Props> = ({ DragHandleComponent, ...dragContext }) => (
    <div className="task-list-item-drag-handle-container" contentEditable={false}>
        <DragHandleComponent {...dragContext} />
    </div>
);

export default TaskListItemDragHandle;
